import {
  Heading,
  Text,
  Button,
  Box,
  Tag,
  IconButton,
  Image,
} from '@everlywell/ui-kit';
import DynamicIcon from 'components/DynamicIcon';
import { usePrePurchaseQuizContext } from 'contexts/PrePurchaseQuiz/PrePurchaseQuizContext';
import React, { useEffect } from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

import mobileModalImage from './images/mobile-ppq-modal-images.png';
import desktopModalImage from './images/ppq-modal-images.png';

export type InitialQuizScreenProps = {};

/**
 * This component adds the Initial Quiz Screen the pre-purchase quiz modal.
 */

// TODO:
// - move content to contentful and fetch it from there

function InitialQuizScreen(props: InitialQuizScreenProps): JSX.Element {
  const { startQuiz, toggleModal, resetState } = usePrePurchaseQuizContext();

  const handleModalClose = () => {
    toggleModal(false);
    resetState();
  };

  useEffect(() => {
    analytics.track({
      event: ANALYTICS.EVENTS.VIEWED_COMPONENT,
      data: {
        label: ANALYTICS.PRE_PURCHASE_QUIZ.LABEL,
        step: ANALYTICS.PRE_PURCHASE_QUIZ.STEPS.INITIAL_SCREEN,
      },
    });
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent={['flex-end', null, 'center']}
      backgroundColor="eggplant.base"
      textAlign="center"
      height="100vh"
      position="relative"
      paddingTop={[5, null, 0]}
    >
      <IconButton
        colorScheme="whiteCS"
        size="sm"
        aria-label="close"
        icon={<DynamicIcon icon="X" color="tints.uiGrey" />}
        onClick={handleModalClose}
        width="40px"
        height="40px"
        position="absolute"
        top="20px"
        right={['24px', null, '70px']}
      />
      <Box maxWidth={[null, '600px']} paddingX="5">
        <Tag
          backgroundColor="eggplant.lighter"
          color="sky.dark"
          marginBottom={['8', '10']}
        >
          Quiz
        </Tag>
        <Heading
          as="h1"
          size="xl"
          color="tints.white"
          marginBottom={['8', '10']}
        >
          Let's see if you're eligible for Weight Care+
        </Heading>
        <Text color="tints.white" marginBottom={['8', '10']}>
          Getting started is the first step! We're going to ask you a few
          questions to determine if you're eligible for the Weight Care+
          program.
        </Text>
        <Button
          variant="primary"
          size={['wide', 'md']}
          colorScheme="whiteCS"
          marginBottom={8}
          onClick={startQuiz}
          // This is a fix to make the button clickable on desktop, even if the bottom image shifts and covers the button
          position="relative"
          zIndex="5"
        >
          Get started
        </Button>
      </Box>

      <Image
        src={mobileModalImage}
        alt="Image of a hexagon pattern and a woman smiling"
        display={['block', null, 'none']} // Show this image on mobile. This is a temporary hack until we move the images to Contentful.
        maxWidth="100%"
      />
      <Image
        src={desktopModalImage}
        alt="Image of a hexagon pattern and a woman smiling"
        display={['none', null, 'block']} // Show this image on desktop. This is a temporary hack until we move the images to Contentful.
        maxWidth="850px"
        position="absolute"
        bottom="0"
      />
    </Box>
  );
}

export default InitialQuizScreen;
